import React, { useCallback, useEffect, useRef } from 'react'

const ClickOutsideListener = props => {
    const { children, clickOutside } = props
    const childRef = useRef(null)

    const eventHandler = useCallback(
        event => {
            if (!childRef.current) {
                return
            }

            if (document.contains(event.target) && !childRef.current.contains(event.target)) clickOutside(event)
        },
        [clickOutside]
    )

    useEffect(() => {
        document.addEventListener('click', eventHandler)

        return () => {
            document.removeEventListener('click', eventHandler)
        }
    }, [eventHandler])

    return React.cloneElement(children, { ref: childRef })
}

export default ClickOutsideListener
